/**
 * Строит строку query-параметров.
 *
 * @param {object} params - Объект с query-параметрами.
 * @returns {string} - Строка запроса в формате key=value, параметры разделены амперсандом (&).
 */
export function buildQueryString(params: object): string {
  return (
    Object.entries(params)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, value]) => Boolean(value))
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          const arrayKey = key.endsWith('[]') ? key : `${key}[]`;
          return value.map(item => `${encodeURIComponent(arrayKey)}=${encodeURIComponent(String(item))}`).join('&');
        }

        return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
      })
      .join('&')
  );
}
